import React, { useEffect, useState } from "react";
import { Card, Typography } from "antd";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import DashboardDateFilter from "./DashboardDateFilter";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";
import { useSelector } from "react-redux";
import { getMySymptomTrackingReport } from "../redux-toolkit/slices/dashboardSlice";

const { Title } = Typography;

const DashboardSymptomTracking = () => {
  const [filter, setFilter] = useState<string>("7");

  const dispatch = useAppDispatch();
  const { isError, isSymptomsFrequencyReportLoading, symptomFrequencyData } =
    useSelector((state: RootState) => state.dashboard);
  useEffect(() => {
    dispatch(getMySymptomTrackingReport(filter));
  }, []);
  const onFilterChange = (filter: string) => {
    setFilter(filter);
    dispatch(getMySymptomTrackingReport(filter));
  };

  const chartOptions: ApexOptions = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },
    },
    colors: ["#2B6CB0", "#E0E0E0"], // Bar chart in dark blue, second bar in light gray
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        // endingShape: 'rounded',
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: symptomFrequencyData.map((item) => item.symptom),
      labels: {
        style: {
          colors: "#333333", // Match text color to screenshot
        },
      },
    },
    yaxis: [
      {
        title: {
          text: "Frequency",
          style: {
            color: "#333333",
          },
        },
        min: 0,
        max: 25,
        labels: {
          style: {
            colors: "#333333",
          },
        },
      },
      {
        opposite: true,
        title: {
          text: "Effectiveness",
          style: {
            color: "#333333",
          },
        },
        min: 0,
        max: 10,
        tickAmount: 5, // Ensure increments of 1
        labels: {
          style: {
            colors: "#333333",
          },
        },
      },
    ],
    fill: {
      opacity: 1,
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "center",
      markers: {
        // radius: 12,
      },
      labels: {
        colors: "#333333",
      },
    },
    grid: {
      borderColor: "#e7e7e7",
    },
  };

  const chartSeries = [
    {
      name: "Frequency",
      type: "bar",
      data: symptomFrequencyData.map((item) => item.frequency), //[12, 14, 20, 10],
    },
    {
      name: "Effectiveness",
      type: "bar",
      data: symptomFrequencyData.map((item) => item.averageRating), //[8, 6, 4, 2],
    },
  ];

  return (
    <Card>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Title level={3}>Symptom Tracking</Title>
        <DashboardDateFilter value={filter} onChange={onFilterChange} />
      </div>
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={350}
      />
    </Card>
  );
};

export default DashboardSymptomTracking;
